var saFooter = ( function($) {

    saFooter = function(options) {
        var that = this;

        // DOM
        that.$wrapper = options["$wrapper"];

        // CONST

        // DYNAMIC VARS

        // INIT
        that.init();
    };

    saFooter.prototype.init = function() {
        var that = this;

        //
        that.method();
    };

    saFooter.prototype.method = function() {
        var that = this;

    };

    return saFooter;

})($);
